import { useTranslation } from 'react-i18next';

const trustItems = [
  { key: 'trust1', icon: 'ri-refresh-line' },
  { key: 'trust2', icon: 'ri-shield-check-line' },
  { key: 'trust3', icon: 'ri-global-line' },
  { key: 'trust4', icon: 'ri-team-line' },
  { key: 'trust5', icon: 'ri-money-dollar-circle-line' },
];

export default function TrustSection() {
  const { t } = useTranslation();

  return (
    <section className="w-full py-10 md:py-14 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-6xl mx-auto">
        <h2 className="text-center font-heading text-xl md:text-2xl font-semibold text-foreground-950 mb-8 md:mb-10">
          {t('trustTitle')}
        </h2>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4 md:gap-5">
          {trustItems.map((item) => (
            <div
              key={item.key}
              className="flex flex-col items-center text-center gap-3 p-5 bg-white border border-background-200 rounded-lg"
            >
              <span className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-50 text-primary-500">
                <i className={`${item.icon} text-lg`}></i>
              </span>
              <span className="text-sm font-medium text-foreground-700 leading-snug">
                {t(item.key)}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}